import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.project-summary.epic-progress.title',
		defaultMessage: '{hierarchyName} progress',
		description: 'Title of the epic/parent issue progress section.',
	},
	description: {
		id: 'contextual-summary.project-summary.epic-progress.description',
		defaultMessage: 'See how your epics are progressing at a glance. <link>View all epics</link>',
		description: 'Description of the epic/parent issue progress section.',
	},
	emptyDescription: {
		id: 'contextual-summary.project-summary.epic-progress.empty-description',
		defaultMessage:
			'Use epics to track larger initiatives in your project. <link>What is an epic?</link>',
		description: 'Description of the epic/parent issue progress section when there is no data.',
	},
	defaultHierarchyName: {
		id: 'contextual-summary.project-summary.epic-progress.default-hierarchy-name',
		defaultMessage: 'Epic',
		description: 'Default name for the EPIC level in the hierarchy.',
	},
	doneLabel: {
		id: 'contextual-summary.project-summary.epic-progress.done-label',
		defaultMessage: 'Done',
		description: 'Label for the done status in the epic progress chart.',
	},
	inProgressLabel: {
		id: 'contextual-summary.project-summary.epic-progress.in-progress-label',
		defaultMessage: 'In progress',
		description: 'Label for the in progress status in the epic progress chart.',
	},
	toDoLabel: {
		id: 'contextual-summary.project-summary.epic-progress.to-do-label',
		defaultMessage: 'To do',
		description: 'Label for the to do status in the epic progress chart.',
	},
});
